import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { useDispatch, useSelector } from "react-redux";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";

interface AboutProps {}

const About = ({}: AboutProps) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  return (
    <>
      <Header />

      <main className="relative w-full">
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  */}
        <MainTitle title={t("About Al Etihad Charity Foundation")} />

        {/* the main content section */}
        <section className="my-[50px] w-full px-[20px] lg:px-0">
          <div className="mainContainer">
            <div className="w-full h-full flex flex-col gap-10 lg:gap-12">
              <p
                className={`${
                  i18n.language === "en"
                    ? "font-Poppins xl:text-left"
                    : "font-Almarai xl:text-right"
                } font-[500] text-[16px] lg:text-[18px] text-second_color lg:max-w-[80%]`}
              >
                {t(
                  "Al Etihad Charity Foundation was established in 1984 as a Quran memorization circle in the mosques of Ajman, to support orphans and children from low-income and underprivileged families in pursuing their education. As the number of beneficiaries increased, these circles evolved into a licensed formal school in 1992, adopting the Ministry of Education curriculum to provide basic education."
                )}
              </p>
              <p
                className={`${
                  i18n.language === "en"
                    ? "font-Poppins xl:text-left"
                    : "font-Almarai xl:text-right"
                } font-[500] text-[16px] lg:text-[18px] text-second_color lg:max-w-[80%]`}
              >
                {t(
                  "In 2003, the foundation expanded its scope to offer various charitable and humanitarian services. In 2019, it received official recognition from the Ministry of Community Development as a licensed charity organization dedicated to supporting underprivileged families and low-income individuals, in addition to implementing humanitarian and development projects across various fields."
                )}
              </p>
              <div className="flex flex-col gap-4">
                <p
                  className={`${
                    i18n.language === "en"
                      ? "font-Poppins xl:text-left"
                      : "font-Almarai xl:text-right"
                  } font-[600] text-[18px] lg:text-[22px] text-second_color lg:max-w-[80%]`}
                >
                  {t("Quality Standards and Governance")}
                </p>
                <p
                  className={`${
                    i18n.language === "en"
                      ? "font-Poppins xl:text-left"
                      : "font-Almarai xl:text-right"
                  } font-[500] text-[16px] lg:text-[18px] text-second_color lg:max-w-[80%]`}
                >
                  {t(
                    "Al Etihad Charity Foundation is committed to adhering to the highest standards of quality and governance to ensure the sustainability of its services and achieve the best possible outcomes. The foundation has obtained internationally recognized certifications, including:"
                  )}
                </p>

                <ul
                  className={`${
                    i18n.language === "en"
                      ? "flex flex-col gap-2 list-disc ml-[40px]"
                      : "flex flex-col gap-2 list-disc mr-[40px]"
                  } text-second_color font-[500]`}
                >
                  <li>{t("ISO 9001:2015 – Quality Management System")}</li>
                  <li>{t("ISO 37301:2021 – Compliance Management System")}</li>
                  <li>{t("ISO 37000:2021 – Corporate Governance Standard")}</li>
                </ul>
                <p
                  className={`${
                    i18n.language === "en"
                      ? "font-Poppins xl:text-left"
                      : "font-Almarai xl:text-right"
                  } font-[500] text-[16px] lg:text-[18px] text-second_color lg:max-w-[80%]`}
                >
                  {t(
                    "These certifications reflect the foundation's continuous commitment to performance improvement, enhancing transparency, and ensuring the delivery of high-quality services to the community while achieving a lasting impact."
                  )}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default About;
